/* eslint-disable no-nested-ternary */
import { useEffect } from 'react';

import { getTokenSocketService, getTokenSocketTestAgentService, getVoiceTokenSocketService } from 'services/accountConversations';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import { receiveData, setSocketStatus } from 'store/socket';
import socket from 'utils/socket';

interface Props {
  isTestAgent?: boolean;
  isTestVoice?: boolean;
}

const useWebSocket = (props?: Props) => {
  const dispatch = useAppDispatch();
  const isTestMode = props?.isTestAgent || props?.isTestVoice;
  const enableWS = useAppSelector((state) => state.system.enableWS);
  const connectWebSocket = () => {
    const functiongetToken = () => {
      if (props?.isTestAgent) {
        return getTokenSocketTestAgentService();
      } if (props?.isTestVoice) {
        return getVoiceTokenSocketService();
      }
      return getTokenSocketService();
    };

    try {
      const { protocol, host } = window.location;
      // const url = 'wss://evol-studio-2025.dev.3forcom.com/ws';
      const url = `${protocol === 'https:' ? 'wss' : 'ws'}://${host}/ws`;
      socket(url, functiongetToken, {
        onStateChange(status) {
          dispatch(setSocketStatus(status));
        },
        onMessage(data) {
          const msg = JSON.parse(data);
          dispatch(receiveData(msg.data));
        },
      }, isTestMode);
    } catch (error) {
      console.error('WebSocket connection error:', error);
      // Throw error when the WebSocket connection fails
    }
  };

  useEffect(() => {
    if (enableWS) {
      connectWebSocket();
    }
  }, [enableWS]);
};

export default useWebSocket;
